import { render, staticRenderFns } from "./BlockedNotifications.vue?vue&type=template&id=ac83bab4"
import script from "./BlockedNotifications.vue?vue&type=script&lang=js"
export * from "./BlockedNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports